const React = require('react');
const LoadingScreen = require('components/LoadingScreen');
const SSOLogin = require('./components/SSOLogin');
const SSOAgreeToTerms = require('./components/SSOAgreeToTerms');
const AuthConstants = require('services/auth-management/constants');
const RoutingTable = require('services/auth-management/routing-table');
const GetQueryParams = require('utils/get-query-params');

const { initLoginContext } = require('../login');
const { initSignupContext } = require('../signup');

// Route used to redirect to SSO login page,
// and callback from the SSO provider
const SSOLoggingInScreen = () => React.createElement(LoadingScreen, {
    variant: 'screen',
    message: 'Logging in...'
});

exports = module.exports = [
    {
        path: '/login-placeholder',
        exact: true,
        component: SSOLoggingInScreen
    },
    {
        path: AuthConstants.authFlow.routes.login.sso,
        exact: true,
        props: {
            flow: 'login'
        },
        component: SSOLogin,
        onWillMount: async () => {

            await initLoginContext();
        }
    },
    {
        path: AuthConstants.authFlow.routes.signup.sso,
        exact: true,
        component: SSOLogin,
        props: {
            flow: 'signup'
        },
        onWillMount: async ({ location } = {}) => {

            const signupContext = await initSignupContext(location);
            const {
                code,
                state
            } = GetQueryParams(location);

            // The provider redirect reloads the app before SSOLogin can restore the
            // persisted callback context. Keep the callback route mounted so the
            // component can complete the token exchange and rebuild signup state.
            if (code && state) {
                return;
            }

            if (signupContext.authMethod !== AuthConstants.authFlow.methods.sso || signupContext.mfaMethod) {
                return {
                    replace: RoutingTable.getIncompleteSignupRoute({ signupContext })
                };
            }
        }
    },
    {
        path: AuthConstants.authFlow.routes.signup.ssoTerms,
        exact: true,
        component: SSOAgreeToTerms,
        onWillMount: async () => {

            const signupContext = await initSignupContext();
            const {
                verificationToken,
                authMethod,
                hasSSOToken
            } = signupContext;

            if (!verificationToken) {
                return { replace: AuthConstants.authFlow.routes.signup.entry };
            }

            if (authMethod !== AuthConstants.authFlow.methods.sso || hasSSOToken !== true) {
                return {
                    replace: RoutingTable.getIncompleteSignupRoute({
                        signupContext
                    })
                };
            }

        }
    }
];
